import { Navigate, useLocation, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const Protected = ({ userRole }) => {
  const { user } = useAuth();
  const location = useLocation();
  return user?.data?.roles.find((role) => userRole.includes(role.code)) ? (
    <Outlet />
  ) : user?.data ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/sign-in" state={{ from: location }} replace />
  );
};

export default Protected;
